import { Combobox } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TimeDisplayFormat } from '@/entities/settings';

type Props = {
  /** Действующее значение общесистемного формата интервалов времени */
  value: TimeDisplayFormat;
  /** Изменение недоступно без права администрирования общих настроек */
  disabled?: boolean;
  /** Сохранение выбранного значения */
  onChange: (value: TimeDisplayFormat) => void;
};

/** Выбор общесистемного формата отображения интервалов времени */
export const TimeDisplayFormatField: FC<Props> = ({ value, disabled, onChange }) => {
  const { t } = useTranslation('generalSettings');

  const options = useMemo(
    () => [
      { value: 'TIME', label: t('timeDisplayFormat.time') },
      { value: 'SECOND', label: t('timeDisplayFormat.seconds') },
    ],
    [t],
  );

  return (
    <div className="flex flex-col gap-2 max-w-md">
      <Combobox
        label={t('timeDisplayFormat.title')}
        options={options}
        value={value}
        disabled={disabled}
        isSearchable={false}
        onChange={(selected) => {
          if (selected && selected !== value) onChange(selected as TimeDisplayFormat);
        }}
      />
      <p className="text-sm text-muted-foreground">{t('timeDisplayFormat.description')}</p>
    </div>
  );
};
